import { render, staticRenderFns } from "./MedicationClassSearchableSelect.vue?vue&type=template&id=3188467b"
import script from "./MedicationClassSearchableSelect.vue?vue&type=script&lang=js"
export * from "./MedicationClassSearchableSelect.vue?vue&type=script&lang=js"
import style0 from "./MedicationClassSearchableSelect.vue?vue&type=style&index=0&id=3188467b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports